var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded == false)?_c('waiting'):_vm._e(),_c('AlertSendForm',{attrs:{"item":_vm.selectedItem},on:{"registItem":_vm.registItem,"clearItem":_vm.clearItem}}),(_vm.loaded)?_c('AlertHistoryList',{attrs:{"listIcon":"mdi-bell","listTitle":"알림 이력","headers":_vm.headers,"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }